import * as React from 'react';

//MUI
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import FaxIcon from '@mui/icons-material/Fax';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import PhoneIcon from '@mui/icons-material/Phone';


import LocationMap from '../components/LocationMap';

import ImageButton from '../components/ImageButton';
import SocialButtons from '../components/SocialButtons';


function Copyright(props) {
  

  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://g.co/kgs/YvzwG1d">
        HOPBON co., ltd.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

function Contact() {
   // Define a fixed width for the entire icon + colon area.
  // Adjust this pixel value until the numbers line up nicely.
  const ICON_AREA_WIDTH = '120px';

  // Component to render a single, perfectly aligned line
  const ContactLine = ({ Icon, number }) => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        paddingTop: '15px',
        paddingBottom: '15px',
        // This ensures the numbers are perfectly aligned across all lines
      }}
    >
      {/* 1. Icon & Colon Area (Fixed Width, Right-Aligned) */}
      <Box
        sx={{
          width: ICON_AREA_WIDTH,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end', // Pushes the icon/colon to the right edge
          flexShrink: 0, // Prevents this area from collapsing
          pr: 1, // Padding right (1 unit, usually 8px)
        }}
      >
        <Icon fontSize="small" sx={{ mr: 0.5 }} />
        <Typography component="span" variant="body1">
          :
        </Typography>
      </Box>

      {/* 2. Number Area (Starts immediately after the fixed-width box) */}
      <Typography variant="body1">
        {number}
      </Typography>
    </Box>
  );

  return (
    <Grid container component="main" sx={{ height: '100vh', paddingTop: '85px', position: 'relative' }}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} sx={{ position: 'relative' }}>
        <LocationMap />
      </Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square sx={{ position: 'sticky', top: '50px', height: 'calc(100vh - 50px)', overflow: 'hidden' }}>
        <Box
          sx={{
            my: 8,
            px: { xs: 2, sm: 5, md: 10, lg: 20 },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography component="h1" variant="h4" paddingTop={'15px'}>
            ติดต่อเรา
          </Typography>
          <Typography component="h1" variant="body1" align='center' paddingTop={'15px'}>
            24, 26, 28 ถนนพุทธมณฑลสาย 3 <br />
            แขวงหนองค้างพลู เขตหนองแขม กรุงเทพฯ 10160 <br />
            <a
              href="https://maps.app.goo.gl/4fLPDyRZXHn9fPHGA?g_st=il"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline" }}
            >
              View on Google Maps
            </a>
            <br />
            <div style={{ textAlign: 'left', display: 'inline-block', paddingBottom: 15, paddingTop: 15 }}>
              <PhoneIcon fontSize='small'/>: (02) 408 9488-9 <br />
              <FaxIcon fontSize='small'/>: (02) 408 9490 <br />
              <PhonelinkRingIcon fontSize='small'/>: (086) 366 0298 - นัท<br />
              <PhonelinkRingIcon fontSize='small'/>: (098) 935 5858 - นน<br />
            </div>
            <br />
            Email: hopbon1999@gmail.com <br />
            
            <br />
          </Typography>
          <SocialButtons/>
          <Copyright/>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Contact;
